'use client';

import type { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BackButton } from '@/app/components/BackButton';
import { usePathname } from '@/i18n/routing';
import appConst from '~/const/appConst';
import { ProfileNavigation } from './ProfileNavigation';

export const ProfileWrapper = ({ children }: PropsWithChildren) => {
  const t = useTranslations('GLOBAL');
  const pathname = usePathname();
  const { profile } = appConst.staticRoutes;
  const [displayMain, setDisplayMain] = useState(pathname !== profile);

  return (
    <section className="profile" data-testid="profile">
      <div className="profile__header">
        <BackButton />
        <h1 className="vp-title-m profile__title">
          {t('MY_PROFILE')}
        </h1>
      </div>
      <ProfileNavigation onClick={setDisplayMain} />
      <div className={classNames('profile__main', {
        'profile__main--visible': displayMain,
      })}
      >
        <BackButton
          href={profile}
          {...pathname === profile && {
            onClick: () => setDisplayMain(false),
          }}
        />
        <div className="profile__page-content">
          {children}
        </div>
      </div>
    </section>
  );
};
